import api from './api';

export const subscriptionService = {
  async createCheckout(plan) {
    return api.post('/subscriptions/checkout', { plan });
  },

  async getStatus() {
    return api.get('/subscriptions/status');
  },

  async cancel(reason) {
    return api.post('/subscriptions/cancel', { reason });
  },

  async getPortalUrl() {
    return api.post('/subscriptions/portal');
  },

  async confirmCheckout(sessionId) {
    return api.post('/subscriptions/confirm', { session_id: sessionId });
  }
};

export default subscriptionService;
